import { forwardRef, PropsWithChildren } from 'react'

import { Box, BoxProps } from 'styled-system/jsx'

export const Content = forwardRef<HTMLDivElement, PropsWithChildren<BoxProps>>(
  ({ children, ...props }, ref) => {
    return (
      <Box
        flexShrink='1'
        flexGrow='1'
        overflowX='hidden'
        overflowY='auto'
        paddingBlock='6'
        paddingInline='9'
        ref={ref}
        {...props}
      >
        {children}
      </Box>
    )
  },
)
